import React from 'react';

export const Table: React.FC<React.TableHTMLAttributes<HTMLTableElement>> = (
  props,
) => (
  <table
    className="min-w-full border border-gray-300 my-4 text-sm text-left"
    {...props}
  >
    {props.children}
  </table>
);

export const Thead: React.FC<React.HTMLAttributes<HTMLTableSectionElement>> = (
  props,
) => <thead {...props}>{props.children}</thead>;

export const Tbody: React.FC<React.HTMLAttributes<HTMLTableSectionElement>> = (
  props,
) => <tbody {...props}>{props.children}</tbody>;

export const Tr: React.FC<React.HTMLAttributes<HTMLTableRowElement>> = (
  props,
) => (
  <tr className="border border-gray-300 last:border-0" {...props}>
    {props.children}
  </tr>
);

export const Th: React.FC<React.ThHTMLAttributes<HTMLTableCellElement>> = (
  props,
) => (
  <th
    className="px-4 py-2 font-semibold bg-gray-50 border border-gray-300 text-gray-700"
    scope="col"
    {...props}
  >
    {props.children}
  </th>
);

export const Td: React.FC<React.TdHTMLAttributes<HTMLTableCellElement>> = (
  props,
) => (
  <td className="px-4 py-2 align-top border border-gray-300" {...props}>
    {props.children}
  </td>
);
